import { cn } from '@utils/cn';

import { Text } from '@ui-component-library/components/Text';

import type { ListProps } from './List.types';

import { listClasses, listItemClasses } from './List.styles';

export const List = ({ items, className }: ListProps) => {
  return (
    <ul className={cn(listClasses(), className)}>
      {items.map((item, index) => (
        <Text
          key={index}
          variant="text-xs/leading-normal/normal"
          as="li"
          className={listItemClasses()}
        >
          {item}
        </Text>
      ))}
    </ul>
  );
};
